module.exports = __webpack_public_path__ + "assets/img/0219.5f9a81ca.png";